<script lang="typescript">
    export let text: any
</script>

{#if text}
    <div class="background">
        <div class:errormsg="{typeof text == 'string' && text.startsWith('FEHLER:')}">
            {#if typeof text === "string"}
                {text}
            {:else}{JSON.stringify(text)}{/if}
        </div>
    </div>
{/if}

<style>
    /*
    .background {
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: fixed;
        background-color: #00000070;
        z-index: 100;
    }
    */

    .background > div {
        left: 0;
        bottom: 0;
        position: fixed;
        margin: auto;
        color: white;
        background-color: #00000099;
        width: 100%;
        padding: 10px;
    }

    .background > div.errormsg {
        font-weight: bold;
        background-color: darkred;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0.8;
        }
    }
</style>
